import { Button } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs';
import { SuccessRoundIcon } from 'app/components/icons';
import { BackActionDialogContentLayout } from 'app/components/layouts';
import useClickOutside from 'app/hooks/useClickOutside';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './PlanChangedSuccessfullyDialog.less';

interface Props {
  onBack: () => void;
}

export default function PlanChangedSuccessfullyDialog({ onBack }: Props) {
  const { t } = useTranslation();

  useClickOutside(onBack);

  return (
    <Dialog className="modal-container plan-changed-successfully-dialog_restricted-width">
      <BackActionDialogContentLayout
        withShadow={false}
        className="plan-changed-successfully-dialog"
        contentProps={{
          className: 'plan-changed-successfully-dialog__content',
        }}
        onBack={onBack}
      >
        <SuccessRoundIcon />

        <h2 className="plan-changed-successfully-dialog__title">
          {t('subscriptions.plan_changed.title')}
        </h2>

        <p className="plan-changed-successfully-dialog__subtitle">
          {t('subscriptions.plan_changed.subtitle')}
        </p>

        <Button
          className="subscription-plan-card__upgrade-button"
          themeColor="primary"
          onClick={onBack}
        >
          <div className="equipment-selection-view__continue-btn-content">
            {t('subscriptions.plan_changed.button')}
          </div>
        </Button>
      </BackActionDialogContentLayout>
    </Dialog>
  );
}
